<div class="edit-shape">
  <h2 class="d-flex justify-content-center mt-2 mb-4">
    {{ 'chinh_sua_hinh_dang' | translate }}

    <div class="close-btn" (click)="close()">
      <i class="bi bi-x"></i>
    </div>
  </h2>
  <div class="editor">
    <div class="col-3 left-panel">
      <div class="d-flex p-2 bg-success text-white justify-content-center align-items-center rounded-pill" 
      style="gap: 8px; font-weight: 700; cursor: help;" nz-tooltip [nzTooltipTitle]="userManualTooltip">
        <span>{{ 'huong_dan_su_dung' | translate }}</span>
        <i class="bi bi-info-square"></i>
      </div>
      <label class="mt-2">{{ 'duong_dan_anh_nen' | translate }}</label>
      <input type="text" [(ngModel)]="bgImage" />
      <div class="d-flex justify-content-between align-items-center mt-2">
        <label>{{'lop_phu' | translate}}</label>
        <nz-switch [(ngModel)]="enableOverlay"></nz-switch>
      </div>
      <div *ngIf="!enableOverlay" class="d-flex justify-content-between align-items-center mt-2">
        <label>{{'do_mo' | translate}}</label>
        <nz-slider [(ngModel)]="opacityOverlay" class="w-50"
          [nzMin]="0.2" [nzMax]="0.8" [nzStep]="0.1"
        ></nz-slider>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-2">
        <label>{{ 'mau_nen' | translate }}</label>
        <input type="color" [(ngModel)]="bgColor" style="width: 50px;" />
      </div>
      <!-- <label>Units</label>
      <select [(ngModel)]="units">
        <option value="percent">%</option>
        <option value="px">px</option>
      </select> -->
      <div class="d-flex justify-content-between align-items-center mt-2">
        <label>{{'buoc_luoi' | translate}} (%)</label>
        <input type="number" [(ngModel)]="gridStepPercent" min="1" style="width: 50px;" />
      </div>
    </div>

    <div class="col-6 center-panel"
    [style.width.px]="width" [style.height.px]="height"
    [style.background-image]="enableOverlay ? 'none' : ('url(' + bgImage + ')')"
    [style.background-size]="'cover'">
      <div class="canvas" #container
      [style.width.px]="width" [style.height.px]="height"
      [style.background-image]="'url(' + bgImage + ')'"
      [style.background-size]="'cover'"
      [style.background-color]="bgColor"
      [style.clip-path]="getClipPath()">
        <!-- SVG overlay (absolute) -->
        <svg #svgOverlay class="overlay" (click)="svgClick($event)"
        [attr.width]="width" [attr.height]="height"
        [style.background]="enableOverlay ? 'none' : ('rgba(255, 255, 255, ' + opacityOverlay + ')')">
          <ng-container *ngIf="shape.kind === 'polygon'">
            <!-- <polygon [attr.points]="polygonPointsStr" fill="rgba(255,255,255,0.15)" stroke="#4A90E2" stroke-width="2" /> -->
            <ng-container *ngFor="let p of shape.points; let i = index">
              <circle
                [attr.cx]="p.x / 100 * width"
                [attr.cy]="p.y / 100 * height"
                r="7"
                fill="#fff"
                stroke="#333"
                stroke-width="1.5"
                (pointerdown)="pointerDownOnHandle($event, { type: 'polygon-point', index: i })"
                (dblclick)="removePolygonPoint(i)"
                style="cursor:grab;"
              />
            </ng-container>
          </ng-container>

          <!-- inset: draw rect based on top/right/bottom/left -->
          <ng-container *ngIf="shape.kind === 'inset'">
            <rect
              [attr.x]="shape.left / 100 * width"
              [attr.y]="shape.top / 100 * height"
              [attr.width]="(100 - shape.left - shape.right) / 100 * width"
              [attr.height]="(100 - shape.top - shape.bottom) / 100 * height"
              fill="rgba(0,0,0,0.15)"
              stroke="#E67E22"
              stroke-width="2"
            ></rect>
            <!-- edge handles -->
            <circle
              [attr.cx]="width / 2"
              [attr.cy]="shape.top / 100 * height"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'inset-edge', edge: 'top' })"
            ></circle>
            <circle
              [attr.cx]="width / 2"
              [attr.cy]="(100 - shape.bottom) / 100 * height"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'inset-edge', edge: 'bottom' })"
            ></circle>
            <circle
              [attr.cx]="shape.left / 100 * width"
              [attr.cy]="height / 2"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'inset-edge', edge: 'left' })"
            ></circle>
            <circle
              [attr.cx]="(100 - shape.right) / 100 * width"
              [attr.cy]="height / 2"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'inset-edge', edge: 'right' })"
            ></circle>
            <!-- corner handles -->
            <ng-container *ngFor="let c of ['tl','tr','br','bl']">
              <circle
                [attr.cx]="(c === 'tl' || c === 'bl') ? (shape.left / 100 * width) : ((100 - shape.right) / 100 * width)"
                [attr.cy]="(c === 'tl' || c === 'tr') ? (shape.top / 100 * height) : ((100 - shape.bottom) / 100 * height)"
                r="6"
                fill="#fff" stroke="#333"
                (pointerdown)="pointerDownOnHandle($event, { type: 'inset-corner', corner: c })"
              ></circle>
            </ng-container>
          </ng-container>

          <!-- ellipse -->
          <ng-container *ngIf="shape.kind === 'ellipse'">
            <ellipse
              [attr.cx]="shape.cx / 100 * width"
              [attr.cy]="shape.cy / 100 * height"
              [attr.rx]="shape.rx / 100 * width"
              [attr.ry]="shape.ry / 100 * height"
              [attr.transform]="'rotate(' + shape.rotation + ' ' + (shape.cx / 100 * width) + ' ' + (shape.cy / 100 * height) +')'"
              fill="rgba(0,0,0,0.15)"
              stroke="#9B59B6"
              stroke-width="2"
            ></ellipse>
            <!-- center handle -->
            <circle
              [attr.cx]="shape.cx / 100 * width" [attr.cy]="shape.cy / 100 * height" r="6"
              fill="#fff" stroke="#333" (pointerdown)="pointerDownOnHandle($event, { type: 'ellipse-center' })"
            ></circle>
            <!-- radius x handle (on rotated ellipse we don't rotate the handle for simplicity) -->
            <circle
              [attr.cx]="(shape.cx / 100 * width) + (shape.rx / 100 * width)"
              [attr.cy]="shape.cy / 100 * height"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'ellipse-radius-x' })"
            ></circle>
            <circle
              [attr.cx]="shape.cx / 100 * width"
              [attr.cy]="(shape.cy / 100 * height) + (shape.ry / 100 * height)"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'ellipse-radius-y' })"
            ></circle>
            <!-- rotation handle -->
            <circle
              [attr.cx]="(shape.cx / 100 * width) + (shape.rx / 100 * width) + 20"
              [attr.cy]="shape.cy / 100 * height"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'ellipse-rotation' })"
            ></circle>
          </ng-container>

          <!-- circle -->
          <ng-container *ngIf="shape.kind === 'circle'">
            <circle
              [attr.cx]="shape.cx / 100 * width"
              [attr.cy]="shape.cy / 100 * height"
              [attr.r]="shape.r / 100  * ( (width + height)/2 )"
              fill="rgba(0,0,0,0.15)"
              stroke="#27AE60" stroke-width="2"
            ></circle>
            <circle
              [attr.cx]="shape.cx / 100 * width"
              [attr.cy]="shape.cy / 100 * height"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'circle-center' })"
            ></circle>
            <circle
              [attr.cx]="(shape.cx / 100 * width) + (shape.r / 100  * ((width + height)/2))"
              [attr.cy]="shape.cy / 100 * height"
              r="6" fill="#fff" stroke="#333"
              (pointerdown)="pointerDownOnHandle($event, { type: 'circle-radius' })"
            ></circle>
          </ng-container>
        </svg>
      </div>
    </div>

    <div class="col-3 right-panel">
      <div class="choose-shape">
        <div class="choose-shape__item" *ngFor="let item of data.clipPathsList"
        (click)="chooseShape($event, item)"
        [class.active]="getClipPath() == item.clipPath">
          <button class="choose-shape__item--inner" [style.clip-path]="item.clipPath"></button>
        </div>
      </div>
    </div>
  </div>

  <div class="actions mt-2">
    <button class="actions__button" (click)="copy('value')">
      {{ 'sao_chep_gia_tri' | translate }}
    </button>
    <!-- <button (click)="makeShareableLink()">Get Shareable Link</button> -->
    <div class="css-output" (dblclick)="startEditing($event)" nz-tooltip
    [nzTooltipTitle]="'nhan_chuot_2_lan_de_chinh_sua_truc_tiep_gia_tri' | translate">
      <code #editInput [contentEditable]="editing" (blur)="saveEditing($event)" (keydown)="onEditKeydown($event)">
        {{ editing ? editingValue : getClipPath() }}
      </code>
    </div>
  </div>
</div>

<ng-template #userManualTooltip>
  <ul class="pl-4 mb-0 py-2 pr-2 text-justify">
    <li>{{ 'nhan_chuot_2_lan_vao_o_gia_tri_de_chinh_sua_truc_tiep' | translate }}</li>
    <li>{{ 'nhan_ctrl_va_nhan_chuot_vao_duong_thang_giua_2_diem_chinh_sua_dem_them_diem_chinh_sua_hinh_dang' | translate }}</li>
    <li>{{ 'nhan_chuot_2_lan_vao_diem_chinh_sua_de_xoa_diem_chinh_sua' | translate }}</li>
    <li>{{ 'nhan_chuot_vao_diem_va_giu_de_thay_doi_hinh_dang' | translate }}</li>
    <li>{{ 'gia_tri_se_duoc_tu_dong_luu_khi_tat_popup' | translate }}</li>
    <li>{{ 'tat_hop_thoai_chi_nhan_dau_x_hoac_nhan_ra_ngoai_se_tat_va_tu_dong_luu' | translate }}</li>
    <li>{{ 'tat_hop_thoai_khong_luu_thi_nhan_phim_esc_tren_ban_phim' | translate }}</li>
  </ul>
</ng-template>